import { defineMessages } from 'react-intl';

export default defineMessages({
  esgQuestion54Title: {
    id: 'features.questionnaires.esgQuestion54Title',
    defaultMessage:
      '5.4 - Gli strumenti finanziari che contribuiranno alla parte del Suo portafoglio indicata nella domanda precedente appartengono a una o più delle tre categorie di seguito elencate. Per ciascuna di queste categorie, può indicare quali corrispondono alle Sue preferenze? (è sufficiente che lo strumento finanziario soddisfi una delle seguenti preferenze)',
    description: 'Main title for ESG question 5.4',
  },
  esgQuestion54SubtitleA: {
    id: 'features.questionnaires.esgQuestion54SubtitleA',
    defaultMessage:
      'a) Strumenti finanziari che tengono conto del loro impatto negativo sui fattori di sostenibilità, ovvero tematiche ambientali, sociali e relative ai diritti umani, di governance',
    description: 'Subtitle for ESG question 5.4 section a)',
  },
  investmentMeasureTitle: {
    id: 'features.questionnaires.investmentMeasureTitle',
    defaultMessage: 'Indicare misura dell’investimento',
    description: 'Subtitle for investmentMeasureTitle',
  },
  factorTitle: {
    id: 'features.questionnaires.factorTitle',
    defaultMessage: 'Selezionare almeno un fattore',
    description: 'Subtitle for factorTitle',
  },
});
